import React from "react";
import { Avatar, Typography, Button, Space, Divider } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const { Text } = Typography;

/**
 * A user profile display component, typically used within a Popover or Dropdown.
 *
 * @param {object} props - The component props.
 * @param {string} props.uname - The name and email of the user.
 * @param {function} props.handleLogout - The function to call when the logout button is clicked.
 * @returns {JSX.Element} The rendered user profile component.
 */
const UserProfilePopup = ({ uname, handleLogout }) => {
  return (
    <div style={{ width: "280px", padding: "8px" }}>
      {/* Account Title */}
      <Text style={{ padding: "8px 16px", color: "rgba(0, 0, 0, 1)",fontWeight:"bold" }}>Account</Text>
      <Divider style={{ margin: "8px 0" }} />

      {/* User Details Section */}
      <div style={{ padding: "8px 16px" }}>
        <Space size="middle" align="center">
          <Avatar 
            size="large" 
            style={{ backgroundColor: "#1890ff", verticalAlign: "middle" }}
          >
            {uname ? uname.charAt(0).toUpperCase() : "?"}
          </Avatar>
          <div>
            {/* The user's name */}
            <Text strong style={{ display: "block" }}>{uname || "Guest User"}</Text>
            {/* The user's email (using the same prop as per the original code) */}
            <Text type="secondary">{uname || "No email provided"}</Text>
          </div>
        </Space>
      </div>

      <Divider style={{ margin: "8px 0" }} />

      {/* Logout Button */}
      <Button
        type="text"
        icon={<LogoutOutlined />}
        onClick={handleLogout}
        style={{ width: "100%", textAlign: "left", padding: "8px 16px", height: "auto" }}
      >
        Logout
      </Button>
    </div>
  );
};

UserProfilePopup.propTypes = {
  /** The name and email of the user */
  uname: PropTypes.string,
  /** Callback function executed on logout */
  handleLogout: PropTypes.func.isRequired,
};

UserProfilePopup.defaultProps = {
    uname: "Anonymous",
}

export default UserProfilePopup;
